export default __webpack_public_path__ + "card-image-sleep-coaches-photo-m.webp";